'use strict';

angular.module('cloudBillingLegacyFrontend').controller('EaPublicAreaCtrl', function () {});
